<template>
<div>
  <el-card body-style="padding: 0">
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="2">
        <el-col :span="5">
          <el-form-item label="订单编号" prop="orderNumbers">
            <el-input v-model="queryForm.orderNumbers" placeholder="请输入订单编号"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="申诉用户" prop="createBy">
            <el-input v-model="queryForm.createBy" placeholder="请输入用户名"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="申诉类型" prop="appealType">
            <el-select v-model="queryForm.appealType" clearable placeholder="请选择">
              <el-option
                  v-for="item in businessOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="1">
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>

  <el-card>
    <el-button type="success" size="small" style="margin: 10px 20px 0 0"
               @click="handleBatchReview()">批量审核
    </el-button>
    <el-table :data="tableData"
              border default-expand-all stripe
              :header-cell-style="{'text-align':'center'}"
              style="width: 100%;margin-bottom: 20px;"
              :cell-style="{'text-align':'center'}"
              @selection-change="handleSelectionChange">
      <el-table-column label="全选" width="50" type="selection"/>
      <el-table-column prop="orderNumbers" label="订单编号" />
      <el-table-column prop="createBy" label="用户" />
      <el-table-column prop="userTypeName" label="用户类型"/>
      <el-table-column prop="appealStatusStr" label="申诉状态" />
      <el-table-column prop="appealTypeStr" width="120" label="申诉类型" />
      <el-table-column prop="createTime" label="申诉时间" />
      <el-table-column prop="appealBeacuse"  label="申诉原因" />
      <el-table-column prop="appealImageUrl"  label="申诉截图">
        <template slot-scope="scope">
          <el-image :src="getImgFirst(scope.row.appealImageUrl)"
                    :preview-src-list="getImgList(scope.row.appealImageUrl)"
                    style="margin: 1%;"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="remarks" label="备注" />
      <el-table-column label="操作" width="250" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" plain v-if="scope.row.appealStatusStr != '审核通过'"
                     @click="handleReviewEdit(scope.$index, scope.row,'申诉审核')">
            审核
          </el-button>
          <el-button size="mini" type="success" plain
                     @click="handleEdit(scope.$index, scope.row, '备注')">
            备注
          </el-button>
          <el-button size="mini" type="success" plain
                     @click="handleReviewEdit(scope.$index, scope.row, '申诉查看')">
            查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>

  <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
    <el-form ref="dialogForm" :model="dialogForm" label-width="230px">
      <el-form-item label="备注">
        <el-input v-model="dialogForm.remarks" style="width: 50%;"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitDialogForm()" size="mini" type="primary">提交</el-button>
      <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>

  <el-dialog :title="dialogReviewTitle" :visible.sync="dialogReviewFormVisible">
    <el-form ref="dialogReviewForm" :model="dialogReviewForm" label-width="220px">
      <!--<el-form-item label="申诉时间">
        <span style="color: red;">{{dialogReviewForm.createTime}}</span>
      </el-form-item>
      <el-form-item label="订单编号">
        <span>{{dialogReviewForm.orderNumbers}}</span>
      </el-form-item>
      <el-form-item label="申诉用户">
        <span>{{dialogReviewForm.createBy}}</span>
      </el-form-item>
      <el-form-item label="用户类型">
        <span>{{dialogReviewForm.userTypeName}}</span>
      </el-form-item>
      <el-form-item v-if="dialogReviewForm.userTypeName == '商家'" label="试客">
        <span>{{dialogReviewForm.quiltAppealPerson}}</span>
      </el-form-item>
      <el-form-item v-else label="商家">
        <span>{{dialogReviewForm.quiltAppealPerson}}</span>
      </el-form-item>
      <el-form-item label="申诉类型">
        <span>{{dialogReviewForm.appealTypeStr}}</span>
      </el-form-item>
      <el-form-item label="申诉原因">
        <span>{{dialogReviewForm.appealBeacuse}}</span>
      </el-form-item>
      <div v-if="dialogReviewForm.appealStatusStr != '审核通过'">
      <el-form-item label="审核操作">
        <el-select v-model="dialogReviewForm.appealStatus" clearable style="width: 30%" size="mini">
          <el-option
              v-for="item in statusOptions"
              :key="item.statusCode"
              :label="item.statusName"
              :value="item.statusCode"
          >
          </el-option>
        </el-select>
      </el-form-item>-->
      <el-form-item label="申诉说明">
        <el-input v-model="dialogReviewForm.appealSaies" style="width: 50%;" size="mini"></el-input>
      </el-form-item>
      <!--</div>
      <div v-else>
        <el-form-item label="申诉状态">
          <span>{{dialogReviewForm.appealStatusStr}}</span>
        </el-form-item>
        <el-form-item label="申诉说明">
          <span>{{dialogReviewForm.appealSaies}}</span>
        </el-form-item>
      </div>-->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitUpdateReview(202111300003)" size="mini" type="primary">审核通过</el-button>
      <el-button @click="submitUpdateReview(202111300002)" size="mini" type="primary">审核不通过</el-button>
      <el-button @click="handleReviewCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import MixinCUD from "../../components/MixinCUD";
import {
  commitAppealMessageRemarks,
  queryAppealList,
  updateAppealMessageInfo,
  updateBatchAppealMessageInfo
} from "../../api/b2cbusiness/b2c_admin";
import {isStrEmpty} from "@/lib/utils";

export default {
name: "AppealManageList",
  mixins:[MixinCUD],
  data() {
    return {
      tableData:[],
      queryFormRefName:"queryForm",
      queryForm:{
        orderNumbers: null,
        createBy: '',
        appealType: null
      },
      shopNameShowPositionAry:[],
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm:{
      },
      dialogReviewFormVisible: false,
      dialogReviewTitle: "",
      dialogReviewRefName: "dialogReviewForm",
      dialogReviewForm:{
        status:0
      },
      businessOptions:[
        {
          label:"本佣金已返买手，买手申请退款",
          value:202202110001,
        },
        {
          label:"本金已返买手，买手申请退款",
          value: 202202110002,
        },
        {
          label:"买手未好评上传错误截图要求商家返佣",
          value: 202202110003,
        },
        {
          label: "买手排错店铺，或者上传错误截图",
          value: 202202110004,
        },
        {
          label:"买手实际花费低于提交的本金",
          value:202202110005,
        },
        {

          label:"买手拍错链接",
          value: 202202110006,
        },
        {
          label:"其他错误",
          value:202202110007
        }
      ],
      statusOptions: [
        {
          statusCode:202111300001,
          statusName:"未审核"
        },
        {
          statusCode:202111300003,
          statusName:"审核通过"
        },
        {
          statusCode:202111300002,
          statusName:"审核未通过"
        }
      ],
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  computed:{
    getImgFirst(){
      return function (imgStr) {
        return isStrEmpty(imgStr)?"":imgStr.split(",")[0]
      }
    },
    getImgList(){
      return function (imgStr) {
        return isStrEmpty(imgStr)?null:imgStr.split(",")
      }
    }
  },
  mounted() {
    if (this.$route.query.appealStatus != null){
      this.queryForm.appealStatus = this.$route.query.appealStatus;
    }
    queryAppealList(this.queryForm, this.pagination).then(res=>{
      if (res.success) {
        console.log(res.data.records);
        this.tableData = res.data.records;
        this.pagination.pageNum = res.data.current;
        this.pagination.pageSize = res.data.size;
        this.pagination.total = res.data.total;
      }
    }).catch(err => {
      this.$message({message: err.message, type: 'error'});
    });
  },
  methods:{
    handleBatchReview(){
      updateBatchAppealMessageInfo(this.multipleSelection).then(res => {
        if (res.success){
          this.$message.success("批量审核成功！");
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    submitUpdateReview(statusCode){
      this.dialogReviewForm.appealStatus = statusCode;
      updateAppealMessageInfo(this.dialogReviewForm).then(res=>{
        if (res.success){
          this.dialogReviewFormVisible = false;
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handleReviewEdit(index, row, dialogTitle){
      this.dialogReviewFormVisible = true;
      this.dialogReviewTitle = dialogTitle
      this.resetDialogReviewForm()
      this.dialogReviewForm = {...row}
    },
    handleReviewCloseDialog(){
      this.$refs[this.dialogReviewRefName].resetFields();
      this.dialogReviewFormVisible = false;
    },
    resetDialogReviewForm(){
      for(let item in this.dialogReviewForm){
        if (typeof this.dialogReviewForm[item]==='string'){
          this.dialogReviewForm[item]='';
        } else if (this.dialogReviewForm[item] instanceof Array) {
          this.dialogReviewForm[item]=[];
        } else{
          this.dialogReviewForm[item]=null
        }
      }
    },
    updateData(){
      console.log(this.dialogForm);
      commitAppealMessageRemarks({id:this.dialogForm.id, remarks:this.dialogForm.remarks}).then(res=>{
        if (res.success) {
          this.dialogFormVisible = false;
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    getData(){
      queryAppealList(this.queryForm, this.pagination).then(res=>{
        if (res.success) {
          console.log(res.data.records);
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handlePageSizeChange(val){
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val){
      this.pagination.pageNum = val;
      this.submitQueryForm()
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}

</style>
